import { tiktokLikeConfig } from '@/lib/analytics/kpis/tiktok/totalLikes';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerLikesConfig = {
    ...tiktokLikeConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
